import { Link } from 'react-router-dom';

/**
 * Header logo that must never be clipped on the right.
 * Wrapper uses overflow-visible and padding so the full image (including "RECHNET") is visible.
 */
// Adaptive width so logo never crops; same value used for wrapper and img
const LOGO_WIDTH = 'clamp(12rem, 28vw, 15rem)';

export default function Logo({ maxHeight = 'max-h-12', asLink = false, to = '/' }) {
  const img = (
    <img
      src="/logo.png"
      alt="Klagma"
      className={`block h-full object-contain object-left rounded-xl ${maxHeight}`.trim()}
      style={{ width: LOGO_WIDTH, minWidth: LOGO_WIDTH, maxWidth: LOGO_WIDTH }}
      draggable={false}
    />
  );

  const wrapperClass = 'flex items-center shrink-0 overflow-visible pr-3';
  const wrapperStyle = { minWidth: LOGO_WIDTH };

  if (asLink) {
    return <Link to={to} className={`h-full ${wrapperClass}`} style={wrapperStyle}>{img}</Link>;
  }
  return <div className={`h-full ${wrapperClass}`} style={wrapperStyle}>{img}</div>;
}
